import SweepOptionType from '../store/schema/SweepOptionType';
import SweepStore from '../store/schema/SweepStore';
import sweepStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetSweepOptionTypeState {
    sweepStore: SweepStore;
}

/**
 * Set the SweepOptionType in sweep store
 * @param key the key as SweepOptionType to set
 * @param state the state which contains the sweep store
 */
export default action('setSweepOptionType')(
    select({
        sweepStore: () => sweepStore,
    })(function setSweepOptionType(key: SweepOptionType, state?: SetSweepOptionTypeState) {
        state.sweepStore.sweepOptionType = key;
    })
);
